//action
import{
    GET_PATIENT_DETAIL,
    GET_PATIENT_DETAIL_FAIL,
    GET_PATIENT_DETAIL_SUCCESS,
    GET_PATIENT_DETAIL_RESET
} from "../action/getPatientDetailAction"
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PATIENT_DETAIL:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_PATIENT_DETAIL_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_PATIENT_DETAIL_SUCCESS:
            console.log("respo",action.response)
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_PATIENT_DETAIL_RESET:
            return initialState
        default:
            return state
    }
}